function init() {

  const translateableContent = [
    '.entry-title',
    '.entry-excerpt',
    '.act-purpose',
    '.act-results',
    '.act-implementation',
    '.campaign-goal-label',
    '.campaign-goal-text',
  ];

  document.querySelectorAll('.js-translation').forEach(el => {
    el.addEventListener('click', (event) => {
      if (!el.classList.contains('active')) {
        const newLang = el.dataset.language;
        translateableContent.forEach(selector => {
          const contentElement = document.querySelector(selector);
          const newText = contentElement.dataset[newLang];
          if (newText !== undefined) {
            if (contentElement) {
              contentElement.querySelector('.text-wrapper').innerHTML = newText;
            }
          }
        });
        document.querySelectorAll('button.active').forEach(button => {
          button.classList.remove('active');
          button.classList.add('secondary');
        });
        el.classList.remove('secondary');
        el.classList.add('active');
      }
    });
  });
}

export default {init};